import CompositeFormField from './composite-field.js';
export default class BankDetailsResponse extends CompositeFormField {
    constructor(parent, el) {
        super(parent, el);
        this.bankDetails = this.el.querySelector('.bank_lookup_bank_details');
        this.bankName = this.field('bankName');
        this.bankAddress1 = this.field('bankAddress1');
        this.bankAddress2 = this.field('bankAddress2');
        this.bankAddress3 = this.field('bankAddress3');
        this.bankPostCode = this.field('bankPostCode');
    }

    setContent(data) {
        const branchData = data?.branchData;
        const address = branchData?.address;
        this.bankName.inputs[0].el.value = branchData?.institutionName;
        this.bankAddress1.inputs[0].el.value = address?.addressLine3;
        this.bankAddress2.inputs[0].el.value = address?.addressLine4;
        this.bankAddress3.inputs[0].el.value = address?.addressLine5;
        this.bankPostCode.inputs[0].el.value = address?.postOrZipCode;
        this.valid().then((valid) => this.update(this, valid));
    }

    valid() {
        return super.valid().then((valid) => {
            this.showResults();
            return valid;
        });
    }

    showResults() {
        this.bankDetails.classList.remove('hide');
    }

    static is(el) {
        return super.is(el) && el.classList.contains('form_field_bank_details_response');
    }
}
